// extracted by mini-css-extract-plugin
export default {"canvasDescription":"CanvasDescription_canvasDescription__UNqov"};